'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

exports.upload = upload;
exports.path = path;

var _ApiClient = require('helpers/ApiClient');

var _ApiClient2 = _interopRequireDefault(_ApiClient);

var _superagent = require('superagent');

var _superagent2 = _interopRequireDefault(_superagent);

var _config = require('../config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var client = new _ApiClient2.default();
var defaultImage = require('theme/images/default-img.jpg');

function upload(file, type) {
  var isPublic = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  return client.get('/files/upload/' + type, {
    params: {
      filename: file.name,
      public: isPublic
    }
  }).then(function (data) {
    return new _promise2.default(function (resolve, reject) {
      var req = _superagent2.default.post(data.form_url);
      (0, _keys2.default)(data.params).map(function (key) {
        req.field(key, data.params[key]);
      });
      req.attach('file', file).end(function (err) {
        var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            body = _ref.body;

        return err ? reject(body || err) : resolve(data.params.key);
      });
    });
  });
}

function path(image) {
  var preset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'thumbnail';
  var style = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var presets = {
    thumbnail: 'w400-h300-cfill-q80',
    listingThumbnail: 'w580-h580-cfill-q80',
    listingCover: 'w580-h580-cfill-q80',
    profileAvatar: 'w340-h340-cfill-q80',
    reviewAvatar: 'w100-h100-cfill-q80',
    reviewAvatar2x: 'w200-h200-cfill-q80',
    profileCover: 'w2600-h800-cfill',
    tripCover: 'w1200-h900-cfill',
    tripCoverNew: 'w1168-h656-cfill',
    tripCoverIphone: 'w1200-h900-cfill',
    tripCoverMobile: 'w600-h450-cfill',
    avatarNavMini: 'w74-h74-cfill',
    avatarNavMini2x: 'w148-h148-cfill',
    avatarReviewCard: 'w140-h140-cfill-q80',
    avatarReviewCard2x: 'w280-h280-cfill-q80',
    coverTripCard: 'w360-h360-cfill-q80',
    coverTripCard2x: 'w720-h720-cfill-q80',
    avatarTripCard: 'w46-h46-cfill',
    avatarTripCard2x: 'w92-h92-cfill',
    featureCover: 'w800-h370-cfill-q80',
    featureCover2x: 'w1600-h740-cfill-q80',
    imageTopic: 'w800-cfill-q80',
    imageTopic2x: 'w1600-cfill-q80',
    inspCol1: 'w660-h440-cfill-q80',
    inspCol2: 'w1320-h440-cfill-q80',
    gallery: 'w2560-q80',
    reviewGallery: 'w1200-h675-q80',
    mobileGallery: 'w1280-q80',
    modalImage: 'w500-h500-q80',
    profileNoti: 'w40-h40',
    'square-300': 'w600-h600-cfill-q80',
    'square-230': 'w230-h230-cfill-q80',
    'square-460': 'w460-h460-cfill-q80',
    'rectangle-800-600': 'w666-h500-cfill-q80',
    'rectangle-600-600': 'w600-h600-cfill-q80',
    'rectangle-400-300': 'w400-h300-cfill-q80',
    'rectangle-300-400': 'w300-h400-cfill-q80',
    'rectangle-600-800': 'w600-h800-cfill-q80',
    'rectangle-310-233': 'w310-h233-cfill-q80',
    'rectangle-620-466': 'w620-h466-cfill-q80',
    tripCardLowRes: 'w31-h23-cfill-q50',
    lxCardCover: 'w620-h300-cfill-q80',
    lxCardAvatar: 'w84-h84-cfill-q80',
    lxCardAvatar2x: 'w168-h168-cfill-q80',
    imagesThumbnail: 'w315-h220-cfill-q80',
    imagesThumbnail2x: 'w630-h440-cfill-q80',
    similarTripCover: 'w310-h200-cfill-q80',
    similarTripAvatar: 'w28-h28-cfill-q80',
    lxAvatar: 'w160-h160-cfill-q80',
    lxAvatar2x: 'w320-h320-cfill-q80',
    articleCover: 'w1200-h500-cfill-q80',
    articleCoverMobile: 'w800-h450-cfill-q80',
    articleImage: 'w800-h600-cfill-q80',
    articleImage2x: 'w1600-h1200-cfill-q80',
    articleThumbnailCover: 'w600-h300-cfill-q80',
    fullSize: '',
    hd: 'w1280-h720-cfill-q80',
    masterGalleryCard: 'w348-h435-cfill-q80'
  };
  if (!image || !image.match(/\.(jpg|jpeg|png|gif|bmp|JPG|JPEG|PNG|GIF|BMP)$/)) {
    if (style) {
      return {
        backgroundImage: 'url(\'' + defaultImage + '\')'
      };
    }
    return defaultImage;
  }
  var url = ('' + _config2.default.mediaPath + (preset === 'fullSize' ? '' : '/' + presets[preset]) + '/' + encodeURI(image)).replace(/\(/g, '%28').replace(/\)/g, '%29');
  if (style) {
    return { backgroundImage: 'url(\'' + url + '\')' };
  }
  return url;
}


//////////////////
// WEBPACK FOOTER
// ./src/utils/media.js
// module id = 21
// module chunks = 47